export function extractDomainFromEmail(email?: string | null): string | undefined {
  if (!email) return undefined;
  const at = email.lastIndexOf("@");
  if (at < 0) return undefined;
  const domain = email
    .slice(at + 1)
    .trim()
    .toLowerCase();
  return domain || undefined;
}

export function uniqueDomainsFromEmails(emails: (string | undefined | null)[]): string[] {
  const domains = new Set<string>();
  for (const email of emails) {
    const domain = extractDomainFromEmail(email);
    if (domain) domains.add(domain);
  }
  return [...domains];
}
